import axios from 'axios'

const api = window.URL_API

export const uploadImage = (token, image, kind, progress, cancel) => {
    var CancelToken = axios.CancelToken;
    var form = new FormData()
    form.append('file', image)
    form.append('origin', kind)
    return axios.post(`${api}/gallery/save/${token}`, form, {
        onUploadProgress: progressEvent => {
            let percentCompleted = Math.floor((progressEvent.loaded * 100) / progressEvent.total);
            progress(percentCompleted)
        },
        cancelToken: new CancelToken(function executor(c) {
            cancel(c)
        })
    })
}

export const getImages = (token, kind, start, limit) => {
    start = start || 0
    limit = limit || 30
    return axios.post(`${api}/gallery/${kind}/${token}/${start}/${limit}`)
}


// WEBPACK FOOTER //
// ./src/SPRINTA/utils/galeryEvents.js